<input (change)="fileSelect($event)" type="file" id="file" style="display:none;" >
<button class="lock btn btn-secondary" (click)="thisFileUpload()">Upload</button>
